<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-left">
          <BreadcrumbsHelper :breadcrumbs="this.Breadcrumbs" />
        </div>
      </div>
    </div>
    <div class="container text-left">
      <b-card class="mt-2">
        <div class="row">
          <div class="col-lg-6">
            <h1 class="title">Badges</h1>
          </div>
          <div class="col-lg-6 text-right">
            <router-link :to="{ name: 'badges create' }">
              <button class="btn btn-secondary"><font-awesome-icon class="icon" icon="plus" /> New Badge</button>
            </router-link>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="table-responsive">
              <table class="table table-sm table-striped text-left">
                <thead>
                  <tr class="text-left">
                    <th>Badge</th>
                    <th>Page</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="tr-sections" v-for="badge in badgeOptions" :key="badge.id">
                    <td>
                      <img :src="badge.imageUrl" class="badge-img" />
                      <router-link :to="{ name: 'badges edit', params: { badgeId: badge.id } }" class="link">{{ badge.name }}</router-link>
                    </td>
                    <td>
                      <a :href="`https://alabama.travel/${badge.page}`" aria-label="opens in a new window" rel="noopener noreferrer" target="_blank" class="link"
                        >{{ badge.page }}<font-awesome-icon class="icon" icon="external-link-alt"
                      /></a>
                    </td>
                    <td class="text-right">
                      <span><router-link class="ellipsis" :to="{ name: 'badges edit', params: { badgeId: badge.id } }">&#8230;</router-link></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import BreadcrumbsHelper from '../common/BreadcrumbsHelper.vue';

export default {
  components: {
    BreadcrumbsHelper,
  },
  data() {
    return {
      Breadcrumbs: [
        {
          text: 'Dashboard',
          href: '/admin',
          active: false,
        },
        {
          text: 'Settings',
          active: true,
        },
        {
          text: 'Badges',
          active: true,
        },
      ],
      badgeOptions: [],
    };
  },

  async mounted() {
    await this.$store.dispatch('misc/getBadges');
    this.badgeOptions = this.$store.state.misc.badges.map(b => ({
      text: b.name,
      id: b._id,
      name: b.name,
      locations: b.location_ids,
      page: b.page,
      imageUrl: `https://alabama-travel.s3.amazonaws.com/partners-uploads/badge/image/${b._id}/${b.image}`,
    }));
  },
};
</script>

<style lang="scss" scoped>
td {
  vertical-align: baseline;
}
.icon {
  font-size: 12px;
  line-height: 30px !important;
  padding-right: 2px;
  text-align: center;
}
.link {
  color: black;
  margin-left: 10px;
  text-decoration: underline;
}
.badge-img {
  width: 70px;
}
.card {
  border: none;
}
.ellipsis {
  color: black;
  font-size: 14px;
}
.title {
  margin: 0px 0px 100px 0px;
}
</style>
